<div id="userTrainingRequirements">
  <app-panel-hub 
    [config]="panelHubConfig" 
    (panelHubStateChanged)="onPanelHubStateChanged($event)"
    (exportClicked)="onExportClicked()"
    *ngIf="isTrainingPlanDataAvailable"
    [pagedData]="pagedData" 
    (panelEventHub)="onPanelEventHubInitialized($event)" 
    class="training-plan-panel">
    
    <!-- Header Template (Collapsed View - Row 1 Only) -->
    <ng-template #headerTemplate let-data="dataVar">
      <div class="grid mb-3">
        <div class="col-fixed" style="width: 44.6%">
          <div class="font-semibold mb-1">Training Item <i class="pi pi-history ml-2 blue-color cursor-pointer" (click)="fetchTrainingOccurrences(data?.number)"></i></div>
          <div *ngIf="data?.type === 'Document'">
            <a class="overflow-ellipse-link" style="cursor: pointer" (click)="openDocument(data?.number, data?.version)">
              <app-read-only readonlyText="{{ data?.number }} {{ data?.title }} (v{{ data?.version }})"
                toolTipMessage="{{ data?.number }} {{ data?.title }} (v{{ data?.version }})">
              </app-read-only>
            </a>
          </div>
          <div *ngIf="data?.type === 'Course'" class="flex items-center gap-2">
            <a class="overflow-ellipse-link" style="cursor: pointer" (click)="openCourse(data?.number)">
              <app-read-only [readonlyText]="data?.number + ' ' + data?.title" [toolTipMessage]="data?.number + ' ' + data?.title">
              </app-read-only>
            </a>
            <em *ngIf="data?.sessionIds?.length" class="pi pi-calendar mt-1 blue-color cursor-pointer" (click)="openSessionDetailsModal(data?.sessionIds)"></em>
          </div>
        </div>

        <div class="col-fixed" style="width: 19%">
          <div class="font-semibold mb-1">Core/Elective</div>
          <div class="content-wrap">
            {{ data?.coreOrElective }}
          </div>
        </div>
        <div class="col-fixed" style="width: 10%">
          <div class="font-semibold mb-1">Training</div>
          <div class="content-wrap">
            <em class="pi pi-circle-fill" [ngClass]="getStatusClass(data?.trainingStatus)"></em>
            {{ data?.trainingStatus }}
          </div>
        </div>              
        <div class="col-fixed" style="width: 13%">
          <div class="font-semibold mb-1">Due Date</div>
          <div class="content-wrap">
            {{ data?.dueDate | date:'dd-MMM-yyyy' }}
          </div>
        </div>
        <div class="col-fixed" style="width: 13%">
          <div class="font-semibold mb-1">Completion Date</div>
          <div class="content-wrap">
            {{ data?.completeDate | date:'dd-MMM-yyyy' }}
          </div>
        </div>             
      </div>
    </ng-template>

    <!-- Content Template (Expanded View - Row 2 Only) -->
    <ng-template #contentTemplate let-data="dataVar">
      <div panel-content>
        <div class="grid">
          <div class="col-fixed" style="width: 8%;padding-left: 0px;">
            <div class="font-semibold mb-1">Type</div>
            <div class="content-wrap">
              {{ data?.type }}
            </div>
          </div>

          <div class="col-fixed" style="width: 12%;">
            <div class="font-semibold mb-1">Manager Update</div>
            <div class="content-wrap">
              {{ data?.isManagerUpdated }}
            </div>
          </div>

          <div class="col-fixed" style="width: 24%">
            <div class="font-semibold mb-1">Curriculum</div>
            <div class="content-wrap">
              <div *ngFor="let curriculum of data?.curriculumNames">{{ curriculum }}</div>
            </div>
          </div>
          <div class="col-fixed" style="width: 19%">
            <div class="font-semibold mb-1">Training Item group</div>
            <div class="content-wrap">
              <div *ngIf="data?.trainingItemGroupNames">
                <div *ngFor="let itemGroup of data.trainingItemGroupNames">{{ itemGroup }}</div>
              </div>
              <div *ngIf="!data?.trainingItemGroupNames">N/A</div>
            </div>
          </div>
          <div class="col-fixed" style="width: 10%">
            <div class="font-semibold mb-1">Status</div>
            <div class="content-wrap">
              <em class="pi pi-circle-fill" [ngClass]="getStatusClass(data?.status)"></em>
              {{ data?.status }}
            </div>
          </div>
          <div class="col-fixed" style="width: 13%">
            <div class="font-semibold mb-1">Assignment Date</div>
            <div class="content-wrap">
              {{ data?.assignmentDate | date:'dd-MMM-yyyy' }}
            </div>
          </div>
          <div class="col-fixed" style="width: 13%">
            <div class="font-semibold mb-1">Expiration Date</div>
            <div *ngIf="data?.type === 'Document'" class="content-wrap">
              {{ data?.expirationDate?.documentExpirationDate}}
            </div>
            <div *ngIf="data?.type === 'Course'" class="content-wrap">
              {{ data?.expirationDate?.courseExpirationDate | date:'dd-MMM-yyyy'}}
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    
  </app-panel-hub>
</div>

<app-training-plan-history-panel-list *ngIf="isTrainingRequirementHistoryModelOpen" [trainingOccurrencesList]="trainingOccurrences" [selectedPuid]="puid || ''"></app-training-plan-history-panel-list>
<app-session-panel-list *ngIf="isSessionDetailsModalOpen"
 [sessionIds]="sessionIdsLinkedWithCourseTrainingOccurrence"
 (showSessionDetailsModal)="closeSessionDetailsModal($event)">
</app-session-panel-list>
